var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoooksReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5001 2.6669H32.7145L32.7145 2.66666C33.3725 2.66666 33.905 3.19953 33.905 3.85722V28.8524V28.8662C33.9025 29.2136 33.7506 29.5261 33.5109 29.7423C32.4482 30.7651 32.4516 32.9067 33.5134 33.9281C34.3159 34.6586 33.7994 36 32.7145 36H9.5001C7.2029 36 5.33473 34.1319 5.33334 31.8352V6.83366C5.33334 4.53617 7.2029 2.6669 9.5001 2.6669ZM27.3574 8.61931H11.8811C11.5525 8.61931 11.2857 8.88587 11.2859 9.21444V17.5478C11.2859 17.8764 11.5525 18.1429 11.8811 18.1429H27.3574C27.6859 18.1429 27.9525 17.8764 27.9525 17.5478V9.21444C27.9525 8.88587 27.6859 8.61931 27.3574 8.61931ZM9.5001 33.6195H30.6135C30.2398 32.4794 30.2398 31.188 30.6135 30.0481H9.5001C8.51555 30.0481 7.71445 30.8492 7.71445 31.8338C7.71445 32.8184 8.51548 33.6195 9.5001 33.6195ZM19.1549 18.6667L13.3333 23.548L19.1549 28.4293V25.3198C22.9152 25.4644 24.6509 27.1638 25.7356 29.3333C25.7356 24.9219 24.2531 21.7762 19.1549 21.523V18.6667Z",
    fill: "#7F5579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoooksReturned);
export default __webpack_public_path__ + "static/media/BoooksReturned.9c7e7964fef4fac2b02867ee00e70468.svg";
export { ForwardRef as ReactComponent };